import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { msalConfig } from './auth/msalConfig';
import { msalInstance } from './auth/msalInstance';
import { AppRoutes } from './routes';
import { ThemeProvider } from './context/ThemeContext';

// MsalProvider requires a non-null instance even when AD is not configured;
// fall back to a throwaway instance for the dev bypass case.
const providerInstance = msalInstance ?? new PublicClientApplication(msalConfig);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <ThemeProvider>
      <MsalProvider instance={providerInstance}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </QueryClientProvider>
      </MsalProvider>
    </ThemeProvider>
  );
}

export default App;
